import { ExcelStyle } from "ag-grid-community";

// Excel-only styling shared by the Ladle Campaigns table and the campaign Heats
// modal. These class names are applied through `cellClass` but have NO matching
// CSS rule, so they affect ONLY the exported .xlsx — never the on-screen grid.
// ag-grid matches a cell's class names against `excelStyles[].id`; the reserved
// ids "header"/"headerGroup" style the header cells automatically.

export const EXCEL_ZEBRA_CLASS = "xlsZebra";
export const EXCEL_BOLD_CLASS = "xlsBold";

export const excelExportStyles: ExcelStyle[] = [
	{
		id: "header",
		font: { bold: true, color: "#FFFFFF" },
		interior: { color: "#479DC4", pattern: "Solid" },
		alignment: { horizontal: "Center", vertical: "Center" },
		borders: {
			borderBottom: { color: "#3A80A0", lineStyle: "Continuous", weight: 1 },
		},
	},
	{
		id: "headerGroup",
		font: { bold: true, color: "#FFFFFF" },
		interior: { color: "#479DC4", pattern: "Solid" },
		alignment: { horizontal: "Center", vertical: "Center" },
	},
	{ id: EXCEL_ZEBRA_CLASS, interior: { color: "#F2F2F2", pattern: "Solid" } },
	{ id: EXCEL_BOLD_CLASS, font: { bold: true } },
];

// cellClass that stripes alternate data rows (Excel-only).
export const zebraCellClass = (params: any): string =>
	params.node?.rowIndex != null && params.node.rowIndex % 2 === 1
		? EXCEL_ZEBRA_CLASS
		: "";

// cellClass for a column whose body cells must be bold AND keep the zebra stripe.
export const boldZebraCellClass = (params: any): string[] =>
	[EXCEL_BOLD_CLASS, zebraCellClass(params)].filter(Boolean) as string[];
